export enum ExceptionalRecognitionCompensationType {
  Cash = 'Cash',
  StockAwards = 'StockAwards'
}
